(ns ballot-scout-v2-frontend.components.breadcrumb-navigator
  (:require
   [ballot-scout-v2-frontend.components.icon :refer [icon] :as icon]))

(defn- nav-item [{:keys [text active? done?]}]
  [:li {:class (when active? "is-active has-text-weight-bold")}
   [:div {:disabled (not done?)
          :class (str "px-3 "
                      (cond done? "has-text-success-dark"
                            (not active?) "has-text-grey disabled"))}
    (when done?
      [:span {:class "icon is-small"}
       [icon ::icon/check-square]])
    [:span text]]])

(defn navigator
  "Returns a breadcrumb navigator UI component, using a `step-titles-map` that maps
   step keyword to text titles and a `current-step` telling the component
   which step to emphazise."
  [step-titles-map current-step]
  (let [phase-idx (first (keep-indexed #(when (= current-step (:phase %2)) %1) step-titles-map))]
    [:nav {:class "navigator breadcrumb has-succeeds-separator"}
     [:ul
      (for [[idx {:keys [label]}] (map-indexed vector step-titles-map)]
        ^{:key (str "breadcrumb-nav-" label)}
        [nav-item {:text label
                   :done? (< idx phase-idx)
                   :active? (= idx phase-idx)}])]]))
